import React, { useMemo } from 'react'
import SliderBasicItemWrapper from './SliderBasicItemWrapper'
import SliderBasicTitle from './SliderBasicTitle'
import SliderBasicInformation from './SliderBasicInformation'
import SliderBasicDescription from './SliderBasicDescription'
import SliderBasicLinkButton from './SliderBasicLinkButton'
import getBackgroundsUrlsObj from '../functions/getBackgroundsUrlsObj'
import getMovieTitle from '../functions/getMovieTitle'
import Translation from '../General/Translation'
import { trackMovieInformationOpen } from '../tracking'
import getTranslationTime from '../functions/getTranslationTime'
import getBackgroundAdObj from '../functions/getBackgroundAdObj'
import getBackgroundPosterObj from '../functions/getBackgroundPosterObj'
import Genres from '../MovieDetails/Genres'
import Length from '../MovieInformation/Length'
import ItemAttributes from '../PosterFormatItem/ItemAttributes'
import seperateAttributes from '../functions/seperateAttributes'
import Directors from '../MovieInformation/Directors'
import { SLIDER } from '../constants/selectionTypes'
import getMomentDateObj from '../functions/getMomentDateObj'
import getMomentNow from '../functions/getMomentNow'
import CountdownContainer from '../MovieInformation/CountdownContainer'
import { useCountdown } from '../hooks/useCountdown'
import FskWrapper from '../MovieInformation/FskWrapper'
import getCinemasPerMovie from '../functions/getCinemasPerMovie'
import SandwichElementTitle from './SandwichElementTitle'


const DefaultLinkText = ({hasPerformance, translation}) => (
    hasPerformance ? (
        <Translation id="tickets" trans={translation}>Tickets</Translation>
    ) : (
        <span><Translation id="information" trans={translation}>Informationen</Translation></span>
    )
)

const SliderBasicItemMovie = ({
    adData,
    movieData,
    oddSlide,
    kenBurnsToggle,
    isJustOneItem,
    canParallax,
    showAvailableIn,
    isCurrentSlide,
    isConnectedFast,
    isInViewport,
    className,
    attributeStyling,
    sliderType,
    hiddenAttributes,
    theme='',
    translation,
    isMobile,
    sliderTitle,
    backgroundVisualsSettings,
    autoplaySpeed,
    eventOrigins,
    onClickSlideItem
}) => {
    const { pk, fsk, descriptionShort, images, directors, startingDate, length, technologyAttributes, performances, genres, trailerURL, limitations } = movieData
    const cinemas = getCinemasPerMovie(performances)
    const {visibleFrom, showCountdown} = limitations
    const { timezone } = translation
    const countdownNumbers = useCountdown(visibleFrom);
    const movieTitle = getMovieTitle(movieData)

    let purchaseblePerformances =  _.filter(performances, performance => {
        const {limitations} = performance

        if(limitations.visibleFrom) {
            // return new Date().getTime() - 5256700000 > limitations.visibleFrom
            const performanceDate = getMomentDateObj(limitations.visibleFrom, timezone)

            return getMomentNow(timezone).isAfter(performanceDate)
        } else {
            return true
        }
    })

    
    const hasPerformance = 0 !== purchaseblePerformances.length
    const formatedDate = startingDate ? getTranslationTime('cinemaStart', translation, startingDate) : visibleFrom ? getTranslationTime('cinemaStart', translation, visibleFrom) : null
    const ticketButtonClass = hasPerformance ? ' has-performances' : ''
    const hasCountdown = !hasPerformance ? ' has-countdown' : ''
    const poster = getBackgroundPosterObj(images)
    const {technologyAttributesWithIcons, technologyAttributesWithoutIcons} = seperateAttributes(technologyAttributes)
    const noAttributesToDisplay = (((technologyAttributesWithIcons.length === 1 && (technologyAttributesWithIcons[0].id === '2d' || technologyAttributesWithIcons[0].id === '1087')) || technologyAttributesWithIcons.length === 0) && (technologyAttributesWithoutIcons.length === 0)) || !showAvailableIn ? true : false
    const noAttributesWithIconsToDisplay = ((technologyAttributesWithIcons.length === 1 && (technologyAttributesWithIcons[0].id === '2d' || technologyAttributesWithIcons[0].id === '1087')) || technologyAttributesWithIcons.length === 0) ? true : false
    
    const backgroundsObj = useMemo(
        () => getBackgroundsUrlsObj(images), 
        [images]
    )

    const el = document.getElementsByClassName("slick-dots " + className)
    let marginBottom = 40

    if(el[0]) {
        marginBottom = el[0].clientHeight + 10
    }

    const styles = {
        marginBottom:  marginBottom
    }

    let itemTitle, itemSubtitle, description, linkURL, linkText, destinationType, trailerUrl, backgroundImage, onClickItem
    
    if(adData) {
        const { title, text, link, imagePoster, position } = adData

        itemTitle = title ? title : movieTitle
        itemSubtitle = false
        description = text ? text : descriptionShort
        linkURL = link && link.url ? link.url : false
        linkText = link && link.text ? link.text : <DefaultLinkText hasPerformance={hasPerformance} translation={translation} /> 
        destinationType = link && link.destinationType ? link.destinationType : false
        trailerUrl = trailerURL ? trailerURL : false
        backgroundImage = imagePoster ? getBackgroundAdObj(imagePoster, position) : backgroundsObj.ambient
        onClickItem = trackMovieInformationOpen(onClickSlideItem, eventOrigins.slide + ', Content "' + itemTitle + '"')
    } else {
        const { subTitle, trailerURL} = movieData
        itemTitle = movieTitle
        itemSubtitle = subTitle
        description = descriptionShort
        linkURL = false
        linkText = <DefaultLinkText hasPerformance={hasPerformance} translation={translation} /> 
        destinationType = false
        trailerUrl = trailerURL
        backgroundImage = backgroundsObj.ambient
        onClickItem = trackMovieInformationOpen(onClickSlideItem, eventOrigins.slide + ', Film')
    }

    return (
        <SliderBasicItemWrapper
            isConnectedFast={isConnectedFast}
            isCurrentSlide={isCurrentSlide}
            isInViewport={isInViewport}
            oddSlide={oddSlide}
            cinemas={cinemas}
            kenBurnsToggle={kenBurnsToggle}
            canParallax={canParallax}
            onClick={() => onClickItem({id: pk, movieTitle: movieTitle})}
            isJustOneItem={isJustOneItem}
            fsk={fsk}
            length={length}
            technologyAttributes={technologyAttributes}
            theme={theme}
            isMobile={isMobile}
            pk={pk}
            hasScrollLink={(linkText && linkURL) ? false : true}
            className={className}
            poster={poster}
            backgroundVisualsSettings={backgroundVisualsSettings}
            autoplaySpeed={autoplaySpeed}
            backgroundImage={backgroundImage}
            trailerURL={trailerUrl}
            translation={translation}
        >
            {sliderTitle && <SandwichElementTitle title={sliderTitle} cinemas={cinemas}/>}

            {theme === 'Arthouse' ? (
                <div className='slide-item-content-wrapper'>
                    <div className='top-section'>
                        <SliderBasicTitle title={itemTitle}/>
                        {itemSubtitle && <p className="title-xlarge-theatre item-subtitle" style={{whiteSpace: "pre-line"}} dangerouslySetInnerHTML={{ __html: itemSubtitle}}></p>}    
                        {sliderType === SLIDER && <div className='row-flex-information'>
                            <Length length={length} translation={translation}/>
                            <FskWrapper fsk={fsk}/>
                            {!noAttributesWithIconsToDisplay && technologyAttributesWithIcons.length !== 0 && <div className='attributes-with-icons'>
                                <ItemAttributes hiddenAttributes={hiddenAttributes} attributeStyling={attributeStyling} translation={translation} attributes={technologyAttributesWithIcons} canBeColored={true} />
                            </div>}
                        </div>}
                        {sliderType === SLIDER && <Genres genres={genres} theme={theme} translation={translation}/>}
                        {sliderType === SLIDER && directors && <Directors directors={directors} actors={[]} translation={translation}/>}
                    </div>
                    <div className='bottom-section'>
                        <div className='headtext'>
                            {!noAttributesToDisplay && <div className='attributes'>
                                {!noAttributesToDisplay && <p className='text-bold attribute-wrapper-title'><Translation id="availableIn" trans={translation}>Verfügbar in</Translation>:</p>}
                                <div className='attributes-container'>
                                    {technologyAttributesWithIcons.length !== 0 && !noAttributesWithIconsToDisplay && <div className='attributes-with-icons'>
                                        <ItemAttributes hiddenAttributes={hiddenAttributes} attributeStyling={attributeStyling} translation={translation} attributes={technologyAttributesWithIcons} canBeColored={true} />
                                    </div>}
                                    {technologyAttributesWithoutIcons.length !== 0 && <div className='attributes-without-icons'>
                                        <ItemAttributes hiddenAttributes={hiddenAttributes} attributeStyling={attributeStyling} translation={translation} attributes={technologyAttributesWithoutIcons} />
                                    </div>}
                                </div>
                            </div>}
                            <SliderBasicDescription description={description}/> 
                        </div>
                        <div>
                            <div className={"slider-item-link" + hasCountdown} style={styles}>
                                {linkURL && linkText ? (
                                    <a className="button-text" target={destinationType && destinationType === 'external' ? '_blank' : '_self'} href={linkURL}>
                                        <SliderBasicLinkButton linkText = {linkText} cinemas={cinemas} className={className}/>
                                    </a>
                                ):(
                                    // <ReactScrollLink to={className + ' movieInformation'} className={pk} smooth={true} offset={-200} onClick={() => onClickItem({id: pk, movieTitle: movieTitle})}>  
                                    <div className={pk}>
                                        <SliderBasicLinkButton linkText={linkText} ticketButtonClass={ticketButtonClass} cinemas={cinemas} className={className}/>
                                    </div>
                                    // </ReactScrollLink>
                                )}
                            </div>
                            <div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className='slide-item-content-wrapper'>
                    <div className="slider-item-text">
                        <SliderBasicTitle title={itemTitle}/>
                        {itemSubtitle && <p className="title-xlarge-theatre item-subtitle" style={{whiteSpace: "pre-line"}} dangerouslySetInnerHTML={{ __html: itemSubtitle}}></p>}
                        <SliderBasicInformation fsk={fsk} directors={directors} translation={translation} length={length}/>
                        <div className='headtext'>
                            {!noAttributesToDisplay && <div className='attributes'>
                                {!noAttributesToDisplay && <p className='text-bold attribute-wrapper-title'><Translation id="availableIn" trans={translation}>Verfügbar in</Translation>:</p>}
                                <div className='attributes-container'>
                                    {technologyAttributesWithIcons.length !== 0 && !noAttributesWithIconsToDisplay && <div className='attributes-with-icons'>
                                        <ItemAttributes hiddenAttributes={hiddenAttributes} attributeStyling={attributeStyling} translation={translation} attributes={technologyAttributesWithIcons} canBeColored={true} />
                                    </div>}
                                    {technologyAttributesWithoutIcons.length !== 0 && <div className='attributes-without-icons'>
                                        <ItemAttributes hiddenAttributes={hiddenAttributes} attributeStyling={attributeStyling} translation={translation} attributes={technologyAttributesWithoutIcons} />
                                    </div>}
                                </div>
                            </div>}
                            {!showAvailableIn && <SliderBasicDescription description={description}/>}
                        </div>
                    </div>

                    <div className={"slider-item-link" + hasCountdown} style={styles}>
                        {linkURL && linkText ? (
                            <a className="button-text" target={destinationType && destinationType === 'external' ? '_blank' : '_self'} href={linkURL}>
                                <SliderBasicLinkButton linkText = {linkText} cinemas={cinemas} className={className}/>
                            </a>
                        ):(
                            // <ReactScrollLink to={className + ' movieInformation'} className={pk} smooth={true} offset={-200} onClick={() => onClickItem({id: pk, movieTitle: movieTitle})}>  
                            <div className={pk}>
                                <SliderBasicLinkButton linkText={linkText} ticketButtonClass={ticketButtonClass} cinemas={cinemas} className={className}/>
                            </div>
                            // </ReactScrollLink>
                        )}
                    </div>
                </div>
            )}
            {(formatedDate || visibleFrom) && showCountdown && !purchaseblePerformances[0] && <div className='countdown-wrapper theme-radius-posters-bottom-left'>
                <CountdownContainer translation={translation} countdownNumbers={countdownNumbers}/>
                <span className='text-xlarge-bold'>{formatedDate}</span>
            </div>}
        </SliderBasicItemWrapper>
    )
}

export default SliderBasicItemMovie